import { ArrowRight } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { welcomeTranslations } from "../../translations/welcomeTranslations";
import { sanitizeHTML } from '../../utils/sanitize';

const CoconSacreWelcome = ({ onOpenEspaceModal }) => {
  const { language } = useLanguage();
  const t = (obj) => obj[language] || obj['fr'];
  const tr = welcomeTranslations;

  return (
    // PREMIUM vertical rhythm - section gap large
    <section className="py-28 px-6 bg-[#516258]">
      <div className="max-w-xl mx-auto text-center">
        {/* Action button - refined spacing */}
        <div className="flex justify-center md:justify-end mb-16">
          <button
            onClick={onOpenEspaceModal}
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#F3E5CF] text-[#3F2A24] text-xs tracking-[0.25em] uppercase font-medium shadow-md hover:bg-[#E8D2B5] transition-colors"
          >
            {t(tr.hero.enterSpace)}
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
        
        {/* Title - PREMIUM letter-spacing */}
        <h2 
          className="font-serif text-3xl md:text-4xl text-[#F3E5CF] mb-14"
          style={{ letterSpacing: '0.04em' }}
        >
          {t(tr.welcome.title)}
        </h2>
        
        {/* Block 1: Introduction - CONTEMPLATIVE line-height with text-wrap balance */}
        <div className="space-y-10 text-[#F3E5CF] mb-16" style={{ lineHeight: '2.1' }}>
          <p className="text-base md:text-lg" style={{ textWrap: 'balance' }} dangerouslySetInnerHTML={sanitizeHTML(t(tr.welcome.p1))} />
          <p className="text-base md:text-lg" style={{ textWrap: 'balance' }} dangerouslySetInnerHTML={sanitizeHTML(t(tr.welcome.p2))} />
        </div>
        
        {/* Decorative separator - premium width */}
        <div className="w-24 h-px bg-[#C5A059]/40 mx-auto mb-16" />
        
        {/* Block 2: Structure & Journey */}
        <div className="space-y-10 text-[#F3E5CF] mb-16" style={{ lineHeight: '2.1' }}>
          <p className="text-base md:text-lg" style={{ textWrap: 'balance' }} dangerouslySetInnerHTML={sanitizeHTML(t(tr.welcome.p3))} />
          <p className="text-base md:text-lg" style={{ textWrap: 'balance' }}>{t(tr.welcome.p4)}</p>
        </div>
        
        {/* Decorative separator */}
        <div className="w-24 h-px bg-[#C5A059]/40 mx-auto mb-16" />
        
        {/* Block 3: Philosophy - slightly softer */}
        <div className="space-y-10 text-[#F3E5CF]" style={{ lineHeight: '2.1' }}>
          <p className="text-[#F3E5CF]/80 text-sm md:text-base" style={{ textWrap: 'balance' }} dangerouslySetInnerHTML={sanitizeHTML(t(tr.welcome.p5))} />
          <p className="text-base md:text-lg" style={{ textWrap: 'balance' }} dangerouslySetInnerHTML={sanitizeHTML(t(tr.welcome.p6))} />
        </div>
      </div>
    </section>
  );
};

export default CoconSacreWelcome;
